import { useDispatch, useSelector } from "react-redux";
import PageHeader from "../../Components/layouts/PageHeader";
import Preloader from "../../Components/Preloader";
import Navbar from "../Menu/Navbar";
import Footer from "./Sections/Footer";
import { AppDispatch, RootState } from "../../apis/store";
import { useEffect } from "react";
import { toGetPartners } from "../../apis/actions/partners.actions";
import { useTranslation } from "react-i18next";

const OurPartners = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { t, i18n } = useTranslation();
  const { list } = useSelector((state: RootState) => state.partners.partners);

  useEffect(() => {
    dispatch(toGetPartners(i18n.language));
  }, [dispatch]);

  return (
    <>
      <Navbar type="internal" />
      <Preloader />
      <main className="main">
        <PageHeader
          current={t("menu.partners")}
          banner="assets/imgs/offres/banner2.png"
          link="our-branches"
        />

        <section className="box-section background-body py-96 border-bottom">
          <div className="container">
            <section className="section-box background-body">
              <div className="container">
                <div className="row align-items-end">
                  <div className="col-md-9 mb-30 wow fadeInUp">
                    <h4 className="title-svg neutral-1000 mb-15 ac--font-expo ac--color-primary">
                      {t("menu.partners")}
                    </h4>
                    <p className="text-lg-medium text-bold neutral-500">
                      {t("banners.title5")}
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <div className="row mt-60">
              {list.map((el: any, index: number) => (
                <div className="col-lg-4 col-sm-6 ">
                  <div
                    className="card-contact card-dealer d-flex align-items-baseline hover-up ac--card-partner"
                    style={{
                      padding: "10px 22px",
                    }}
                  >
                    <div
                      className={`card-image ${
                        i18n.language === "ar" ? "ms-3" : "me-3"
                      } me-3`}
                    >
                      <div className="position-relative">
                        <img width={70} src={el.image_1920} alt={el.title} />
                      </div>
                    </div>
                    <div className="card-info">
                      <div className="card-title">
                        <span className="title heading-6 ac--font-expo ac--color-primary">
                          {el.name}
                        </span>
                        <p className="text-md-medium neutral-500 ac--font-expo ">
                          {el.summary}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <Footer type="external" />
      </main>
    </>
  );
};

export default OurPartners;
